import NoInlineResultSearcher from "./NoInlineResultSearchers"

class DaataSearcher extends NoInlineResultSearcher {
    key = 'daata';
    searcherName = 'Tel Aviv University libraries (Daata)';
    infoText = 'Tel Aviv University libraries (Daata)';
    typeFilter2urlSection = 
        {   "All types" : {suffix: ""},
            "Books" : {suffix: "&pfilter=pfilter,exact,books,AND"},
            "Dissertations" : {suffix : "&mfacet=rtype,include,theses,1&mfacet=rtype,include,theses_phd,1&mfacet=rtype,include,dissertations,1&mfacet=rtype,include,theses_md,1&mfacet=rtype,include,theses_ma,1"},
            "Images" : {suffix : "&pfilter=pfilter,exact,images,AND"},
            'Legislation / Government publications' : {suffix: "mfacet=rtype,include,government_documents,1"},
            'Manuscripts' : {suffix : '&pfilter=pfilter,exact,archives,AND'},
            'Maps' : {suffix : '&pfilter=pfilter,exact,maps,AND'},
            'Notated music' : {suffix : '&pfilter=pfilter,exact,scores'},
            'Newspapers' : {suffix : '&mfacet=rtype,include,newspaper_articles,1'},
            'Periodicals' : {suffix : '&pfilter=pfilter,exact,articles,AND'},
            'Video' : {suffix : '&pfilter=pfilter,exact,audio_video,AND'},
            'Web Page' : {suffix : '&mfacet=rtype,include,websites,1'},
        }
    multiTypeFilterSupported = false;
    dateFilterSupported = true;

    fillTargetWebsiteUrl(value, store) { 
        console.log(store.searchInput)
        this.targetWebsiteUrl = "https://tau-primo.hosted.exlibrisgroup.com/primo-explore/search?query=any,contains,"+
        encodeURIComponent(value)+
        ",AND&query=sub,contains,United%20States,AND&tab=default_tab&search_scope=TAU_Blended&sortby=rank&vid=TAU2&mode=advanced&offset=0" +
        this.typeFilter2urlSection[store.searchInput.selectedTypes[0]]['suffix'] +
        (store.searchInput.dates === null ? "" : "&facet=searchcreationdate,include," + store.searchInput.dates[0] + "%7C,%7C" + store.searchInput.dates[1]) + 
        (store.state.language === 'he' ? "&lang=iw_IL" : "");



    }
}

class UliSearcher extends NoInlineResultSearcher {
    key = 'ULI';
    searcherName = 'Unified Israeli libraries catalog (ULI)';
    infoText = "Unified Israeli libraries catalog (ULI)";
    typeFilter2urlSection = 
        {   "All types" : {suffix: ""},
            "Audio" : {suffix : "&mfacet=local48,include,Audio,1"},
            "Books" : {suffix: "&pfilter=pfilter,exact,books,AND"},
            "Dissertations" : {suffix : "&pfilter=pfilter,exact,dissertations"},
            "Images" : {suffix : "&pfilter=pfilter,exact,images,AND"},
            'Maps' : {suffix : '&pfilter=pfilter,exact,maps,AND'},
            'Notated music' : {suffix : '&pfilter=pfilter,exact,scores'},
            'Video' : {suffix : '&pfilter=pfilter,exact,audio_video,AND'},
            'Web Page' : {suffix : '&pfilter=pfilter,exact,websites'},
        }
    multiTypeFilterSupported = false;
    dateFilterSupported = true;

    fillTargetWebsiteUrl(value, store) { 
        this.targetWebsiteUrl = "http://primo.nli.org.il/primo-explore/search?query=any,contains," + 
        encodeURIComponent(value)+
        ",AND&query=sub,contains,United%20States,AND&tab=default_tab&search_scope=ULI&sortby=rank&vid=ULI&mode=advanced&offset=0" +
        this.typeFilter2urlSection[store.searchInput.selectedTypes[0]]['suffix'] +
        (store.searchInput.dates === null ? "" : "&facet=searchcreationdate,include," + store.searchInput.dates[0] + "%7C,%7C" + store.searchInput.dates[1]) + 
        (store.state.language === 'he' ? "&lang=iw_IL" : "")

    }
}

export {DaataSearcher, UliSearcher}